export default function SvgCheckbox() {
  return (
    <>
      <svg width="20px" cursor="pointer" fill="#00cc00" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M400 48H112a64.07 64.07 0 00-64 64v288a64.07 64.07 0 0064 64h288a64.07 64.07 0 0064-64V112a64.07 64.07 0 00-64-64zm-35.75 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"></path>
      </svg>
    </>
  );
}
